define('headerDesignersView',[
  'app',
  'module',
  'backbone',
  'marionette',
  'underscore',
  'settings',
  'userView',
  'template!headerDesignersView'
], function(
  App,
  module,
  Backbone,
  Marionette,
  _,
  Settings,
  UserView,
  Tpl
) {
  'use strict';

  module.exports = Marionette.CompositeView.extend({
    template: Tpl,
    className: 'header-designers-view',
    childView: UserView,
    childViewContainer: '.users-container',

    collectionEvents: {
      'reset': 'onRender',
      'add': 'onRender',
      'remove': 'onRender'
    },

    ui: {
      usersContainer: '.users-container',
      empty: '.empty'
    },
   
    initialize: function () {
      this.collection = new Backbone.Collection();    
      this.fetch();
    },

    onRender: function () {
      if(this.collection.length > 0) {
        this.ui.empty.hide();
        this.ui.usersContainer.css('display', 'flex');
      }
      else {
        this.ui.empty.show();
        this.ui.usersContainer.hide();
      }
    },

    fetch: function () {          
      var params = {
        lang: Settings.get('lang'),
        online: true 
      };     

      var url = Settings.url('compuzz2', 'v2/caccounts/usersActivity', params);

      if (this.fetchRequest)
        this.fetchRequest.abort();

      this.fetchRequest = $.ajax({
        type: 'GET',
        url: url,
        success: _.bind(function (users) {    
          this.collection.reset();

          _.each(users, function (user) {
            var model = App.request('caccount-admins:get-model', user);
            if (model.get('userpidGroups') && _.where(model.get('userpidGroups'), { showAsGraph: true }).length > 0) {
              this.collection.add(model);
            }
          }, this);
        }, this)
      });
    }
  });
});
